/**
 * Generated bundle index. Do not edit.
 */

export {ExtendedAngularFirestoreModule,ExtendedAngularFirestore} from './public_api';
